const RG_MIN_LENGTH = 5;
const RG_MAX_LENGTH = 14;

export type RGErrorKey =
  | 'prefix_too_long'
  | 'x_not_at_end'
  | 'letters_in_middle'
  | 'too_short'
  | 'too_long'
  | 'identical_digits';

export const normalizeRG = (value: string): string => value.toUpperCase().replace(/[^A-Z0-9]/g, '');

export const getRGFullError = (value: string): RGErrorKey | null => {
  if (!value) {
    return null;
  }

  const rg = normalizeRG(value);

  if (!rg) {
    return null;
  }

  const prefixMatch = /^([A-Z]+)/.exec(rg);
  if (prefixMatch && (prefixMatch[1]?.length ?? 0) > 2) {
    return 'prefix_too_long';
  }

  if (/X./.test(rg)) {
    return 'x_not_at_end';
  }

  const withoutPrefix = rg.replace(/^[A-Z]{0,2}/, '');
  if (/[A-Z]/.test(withoutPrefix.replace(/X$/, ''))) {
    return 'letters_in_middle';
  }

  if (rg.length < RG_MIN_LENGTH) {
    return 'too_short';
  }

  if (rg.length > RG_MAX_LENGTH) {
    return 'too_long';
  }

  const numbers = rg.replace(/\D/g, '');
  if (/^(\d)\1+$/.test(numbers)) {
    return 'identical_digits';
  }

  return null;
};
